(() => {
  function placePolicyDetails() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const info = productInfo.querySelector('.product__info-container');
      const policyBlocks = [...productInfo.querySelectorAll('.wp-product-media-details')];
      if (!info || policyBlocks.length === 0) return;

      const policy = policyBlocks[0];
      policyBlocks.slice(1).forEach((duplicate) => duplicate.remove());
      const anchor = info.querySelector('.product__view-details');
      if (anchor) {
        if (anchor.nextElementSibling !== policy) anchor.insertAdjacentElement('afterend', policy);
      } else if (policy.parentElement !== info) {
        info.appendChild(policy);
      }
    });
  }

  function bindThumbnailRail() {
    document.querySelectorAll('.wp-product-thumbnail-slider').forEach((rail) => {
      if (rail.dataset.wpVerticalRailBound === 'true') return;

      const list = rail.querySelector('.thumbnail-list');
      if (!list) return;

      rail.dataset.wpVerticalRailBound = 'true';
      rail.querySelectorAll('.slider-button').forEach((button) => {
        button.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            const direction = button.name === 'previous' ? -1 : 1;
            const isMobile = window.matchMedia('(max-width: 749px)').matches;
            if (isMobile) {
              list.scrollBy({ left: direction * Math.max(list.clientWidth * 0.9, 120), behavior: 'smooth' });
            } else {
              list.scrollBy({ top: direction * Math.max(list.clientHeight * 0.82, 120), behavior: 'smooth' });
            }
          },
          true
        );
      });
    });
  }

  function bindMobileGalleryProgress() {
    document.querySelectorAll('media-gallery.wp-product-gallery').forEach((gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const list = viewer?.querySelector('.product__media-list');
      const slides = list ? [...list.querySelectorAll('.product__media-item')] : [];
      if (!viewer || !list || slides.length < 2) return;

      let progress = viewer.querySelector('.wp-mobile-gallery-progress');
      if (!progress) {
        progress = document.createElement('div');
        progress.className = 'wp-mobile-gallery-progress';
        progress.setAttribute('role', 'tablist');
        progress.setAttribute('aria-label', 'Choose product image');
        progress.innerHTML = slides
          .map(
            (_, index) =>
              `<button type="button" class="wp-mobile-gallery-progress__segment" role="tab" aria-label="Show product image ${index + 1}" aria-controls="${slides[index].id}" data-slide-index="${index}"></button>`
          )
          .join('');
        viewer.prepend(progress);
      }

      const segments = [...progress.querySelectorAll('.wp-mobile-gallery-progress__segment')];
      const setActive = (index) => {
        const activeIndex = Math.max(0, Math.min(index, segments.length - 1));
        segments.forEach((segment, segmentIndex) => {
          const active = segmentIndex === activeIndex;
          segment.classList.toggle('is-active', active);
          segment.setAttribute('aria-selected', active ? 'true' : 'false');
          segment.setAttribute('tabindex', active ? '0' : '-1');
        });
      };

      if (progress.dataset.wpBound !== 'true') {
        progress.dataset.wpBound = 'true';
        segments.forEach((segment) => {
          segment.addEventListener('click', () => {
            slides[Number(segment.dataset.slideIndex)]?.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start',
            });
          });
        });

        let ticking = false;
        list.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
              ticking = false;
              const listRect = list.getBoundingClientRect();
              const listCenter = listRect.left + listRect.width / 2;
              let closestIndex = 0;
              let closestDistance = Number.POSITIVE_INFINITY;
              slides.forEach((slide, index) => {
                const rect = slide.getBoundingClientRect();
                const distance = Math.abs(rect.left + rect.width / 2 - listCenter);
                if (distance < closestDistance) {
                  closestDistance = distance;
                  closestIndex = index;
                }
              });
              setActive(closestIndex);
            });
          },
          { passive: true }
        );
      }

      const activeSlide = slides.findIndex((slide) => slide.classList.contains('is-active'));
      setActive(activeSlide >= 0 ? activeSlide : 0);
    });
  }

  function primeGalleryMedia(gallery) {
    if (!gallery || gallery.dataset.wpMediaPrimed === 'true') return;
    gallery.dataset.wpMediaPrimed = 'true';

    const preload = () => {
      gallery.querySelectorAll('[data-media-id] img').forEach((image) => {
        image.loading = 'eager';
        image.decoding = 'async';
        const source = image.currentSrc || image.src;
        if (!source) return;
        const preloadedImage = new Image();
        preloadedImage.decoding = 'async';
        preloadedImage.src = source;
      });
    };

    if ('requestIdleCallback' in window) window.requestIdleCallback(preload, { timeout: 500 });
    else window.setTimeout(preload, 0);
  }

  function activateMedia(gallery, mediaId) {
    if (!gallery || !mediaId || typeof gallery.setActiveMedia !== 'function') return;
    gallery.setActiveMedia(mediaId, false);
  }

  function bindInstantMediaSelection() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (productInfo.dataset.wpInstantMediaBound === 'true') return;
      productInfo.dataset.wpInstantMediaBound = 'true';

      const gallery = productInfo.querySelector('media-gallery');
      primeGalleryMedia(gallery);

      productInfo.addEventListener(
        'change',
        (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || !input.matches('.wp-product-option--sku-images input[data-wp-media-id]')) return;
          activateMedia(gallery, input.dataset.wpMediaId);
        },
        true
      );

      gallery?.addEventListener(
        'pointerdown',
        (event) => {
          const target = event.target instanceof Element ? event.target.closest('.thumbnail[data-target]') : null;
          activateMedia(gallery, target?.dataset.target);
        },
        true
      );
    });
  }

  function initialize() {
    placePolicyDetails();
    bindThumbnailRail();
    bindMobileGalleryProgress();
    bindInstantMediaSelection();
  }

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
